import React from 'react'
import DialogBubble from './DialogBubble'
import FileMessage from './messageTypes/FileMessage'
import ImageMessage from './messageTypes/ImageMessage'
import StringMessage from './messageTypes/StringMessage'

const Message = (props) => {
  const { message } = props

  switch (message.type) {
    case 'string':
      return (
        <DialogBubble {...props}>
          <StringMessage {...props} />
        </DialogBubble>
      )
    case 'image':
      return (
        <DialogBubble {...props}>
          <ImageMessage {...props} />
        </DialogBubble>
      )
    case 'file':
      return (
        <DialogBubble {...props}>
          <FileMessage {...props} />
        </DialogBubble>
      )

    default:
      console.error('Unhandled Message Type', message)
      return null
  }
}

export default Message
